"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./ImageItem.css");
var icons_1 = require("@tiendanube/icons");
var Link_1 = __importDefault(require("../Link"));
var Text_1 = __importDefault(require("../Text"));
function ImageItem(_a) {
    var thumbnail = _a.thumbnail, link = _a.link, subtitle = _a.subtitle, description = _a.description;
    var _b = React.useState(false), errorLoad = _b[0], setErrorLoad = _b[1];
    var handleError = React.useCallback(function () { return setErrorLoad(true); }, []);
    var renderThumbnail = thumbnail && !errorLoad ? (React.createElement("img", { src: thumbnail, alt: link.children, onError: handleError })) : (React.createElement("div", { className: "nimbus--image-item__placeholder" },
        React.createElement(icons_1.CameraIcon, { size: "large" })));
    var renderSubtitle = subtitle && (React.createElement(Text_1.default, { appearance: subtitle.appearance }, subtitle.children));
    var renderDescription = description && (React.createElement(Text_1.default, { appearance: description.appearance }, description.children));
    return (React.createElement("div", { className: "nimbus--image-item" },
        React.createElement("div", { className: "nimbus--image-item__thumbnail", "aria-label": link.children }, renderThumbnail),
        React.createElement("div", { className: "nimbus--image-item__info" },
            React.createElement(Link_1.default, { appearance: "primary", onClick: link.onClick }, link.children),
            renderSubtitle,
            renderDescription)));
}
var Skeleton = function () { return (React.createElement("div", { className: "nimbus--image-item-skeleton" },
    React.createElement("div", { className: "nimbus--image-item-skeleton__thumbnail" }),
    React.createElement("div", { className: "nimbus--image-item-skeleton__info" },
        React.createElement(Text_1.default.Skeleton, { width: "large" }),
        React.createElement(Text_1.default.Skeleton, { width: "medium" }),
        React.createElement(Text_1.default.Skeleton, { width: "small" })))); };
ImageItem.Skeleton = Skeleton;
exports.default = ImageItem;
//# sourceMappingURL=index.js.map